import { memo } from 'react';

import { IconButton } from '@components/icon-button';
import { IconReplace } from '@components/icons/replace';
import { getScopedTranslate } from '@locale/translate';

import { JourneyAction } from 'api/types';
import { ACTION_TYPES, getActionLabel } from 'ui/actions/action-config';
import { showReplaceActionModal } from 'ui/journey-builder/create-action/add-action-modal';
import { ActionRemoveButton, nodeToActionBasic } from 'ui/journey-builder/node-types/common';
import { JourneyNodeActionCard, NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

const ACTION_TYPE = ACTION_TYPES.placeholder;

export const getDescription = (action: JourneyAction<typeof ACTION_TYPE>) => {
  const { t } = getScopedTranslate(nodeLocale);
  return action.description ?? t('noDescription');
};

export const Node = memo((node: JourneyNode<typeof ACTION_TYPE>) => {
  const handleReplace = () => {
    showReplaceActionModal({ replaceActionId: node.id });
  };

  return (
    <NodeContainer node={node}>
      <JourneyNodeActionCard node={node} label={getActionLabel(ACTION_TYPE)}>
        <ActionRemoveButton action={nodeToActionBasic(node)} size="md" />
        <IconButton
          icon={<IconReplace />}
          variant="ghost-purple"
          size="md"
          stopPropagation
          onClick={handleReplace}
        />
      </JourneyNodeActionCard>
    </NodeContainer>
  );
});

const nodeLocale = {
  en: {
    noDescription: 'No description',
  },
};
